
  var base_url="https://winebottles.aliansoftware.net/public/";
  var shop_url= store_name;
  var customer_id=cust_id;
  var template_name =template_name;
if(template_name == 'account'){
  
  var url = $(location).attr('href'),
        parts = url.split("="),
        last_part = parts[parts.length-1];
  if($.isNumeric(last_part) && last_part!=0){
  	
    		window.location.href='/pages/wine-bottles?plan_id='+last_part;
    	
  
  		
  
  }
  else{
  
  	$.ajax({
        url: base_url+ 'getCountry',
        method: 'GET',
        dataType: 'json',
        contentType: "application/json",
        async: false,
        success: function (response) {
        	debugger;
          $('#country').append("");
          $('#country_bill').append("");
          if(response){
          	var option="";
            var len = response[0].data.length;
            var j=0;
            for(j=0;j<len;j++){
            
            option +="<option value='"+response[0].data[j]+"'>"+response[0].data[j]+"</option>";
              
            }
            $('#country').append(option);
            $('#country_bill').append(option);
          
          }
          
            $.ajax({
                url: base_url + 'get_address',
                method: 'GET',
                dataType: 'json',
                contentType: "application/json",
                async: false,
                data: {'shop_url':shop_url,customer_id:customer_id},
                success: function (data) {
                   debugger;
                  if(data != 1 && data !=2){
					
                    //product details
                     var pro_len=data[3].length;
                     var l=0;
                     var products="";
                    for(l;l<pro_len;l++){
                       var pro_name=data[3][l].split('-');
						
                    	products +="<p>"+pro_name[0]+" x "+pro_name[1]+"</p>";
                    }
                    
                    $('#product_details').after(products);
                    
                    //end product details
 					//Sub status
                    var status=data[4] == 1?'Active':'Inactive';
                    $('#sub_status').prepend(status);	
                    //end Sub status
                    
                   
                    
                    $('#shipping_details').hide();
                    $('#billing_details').hide();
                    //For Tab 1
					
                    if(data[0].length >0){
                    	if(data[0][0].Shipping_Country == "United States"){
                    	var country = "United States of America";
                    }else{
                     var country = 	data[0][0].Shipping_Country;
                    }
                    
                    if(data[0][0].Billing_Country == "United States"){
                    	var country = "United States of America";
                    }else{
                     var country = 	data[0][0].Billing_Country;
                    }
                    
                    
                    $('#first_name').val(data[1]);
                    $('#last_name').val(data[2]);
                    $('#address').val(data[0][0].Shipping_Address1);
                    $('#address_2').val(data[0][0].Shipping_Address2);
                    $('#company').val(data[0][0].Shipping_Company);
                    $('#city').val(data[0][0].Shipping_City);
                    $('#postal_code').val(data[0][0].Shipping_Zip_code);
                    $('#country').val(country);
                    

                    //Billing Address
                    $('#firstname').val(data[1]);
                    $('#lastname').val(data[2]);
                    $('#address1').val(data[0][0].Billing_Address1);
                    $('#address2').val(data[0][0].Billing_Address2);
                    $('#company_bill').val(data[0][0].Billing_Company);
                    $('#city_bill').val(data[0][0].Billing_City);
                    $('#postal_code_bill').val(data[0][0].Billing_Zip_code);
					$('#country_bill').val(country);
                    //End Tab 1
                    
                    var shipp= "<p class='info'>"+data[0][0].Shipping_Address1+"<br>"+data[0][0].Shipping_Address2+"<br>"+data[0][0].Shipping_City+ ','+data[0][0].Shipping_Zip_code+ "<br>"+country+"</p>";
                    
                    var main_shipp="<p>"+data[0][0].Shipping_Address1+"<br>"+data[0][0].Shipping_Address2+"<br>"+data[0][0].Shipping_City+ ','+data[0][0].Shipping_Zip_code+ "<br>"+country+"</p>";
                    
                    var bill = "<p class='info'>"+data[0][0].Billing_Address1+"<br>"+data[0][0].Billing_Address2+"<br>"+data[0][0].Billing_City+ ','+data[0][0].Billing_Zip_code+ "<br>"+country+"</p>";
                    $('#shipping_information').after(shipp);
                    $('#billing_address').after(bill);
                    $('#main_shipping').after(main_shipp);
                   }
                     OrderDetails();
                     SubscribtionProduct();
                     ManageUpcomingOrder();
                    
                  }else if(data ==2){
                     $('.manage_subscription').html("You Plan is Deactivated");
                  }else{
                  	var address="<p class='info'>No Address Found</>";
                    $('#shipping_information').after();
                     OrderDetails();
                     SubscribtionProduct();
                     ManageUpcomingOrder();
                  
                  }
                },
        error: function () {
            alert("Something went wrong");
        }
   	 });
          
          
          
    },
    error:function(){
      alert('error');
    }	
  
  

  });
  	
  $('#save_shipping').on('click',function(){
    debugger;
    	var firstname=$('#first_name').val();
        var lastname=$('#last_name').val();
        var address=$('#address').val();
        var address_2=$('#address_2').val();
    	var company=$('#company').val();
    	var country=$('#country').val();
    	var city=$('#city').val();
    	var postal_code=$('#postal_code').val();
    
  		$.ajax({
            url: base_url +'update_shipping',
            method: 'GET',
            dataType: 'json',
            contentType: "application/json",
            async: false,
         	data: {shop_url:shop_url,customer_id:customer_id,firstname:firstname,lastname:lastname,country:country,address:address,address_2:address_2,company:company,city:city,postal_code:postal_code},
            success: function (res) {
               debugger;
                   if(res == 1){
                  	window.location.reload();
                  }    

            },
            error: function () {
                alert("Something went wrong");
            }
      });
  })
  
  $('#save_billing').on('click',function(){
    debugger;
  		var firstname=$('#firstname').val();
        var lastname=$('#lastname').val();
        var address=$('#address1').val();
        var address_2=$('#address2').val();
    	var company=$('#company_bill').val();
    	var country=$('#country_bill').val();
    	var city=$('#city_bill').val();
    	var postal_code=$('#postal_code_bill').val();
    
    	$.ajax({
            url: base_url+'update_billing',
            method: 'GET',
            dataType: 'json',
            contentType: "application/json",
            async: false,
         	data: {shop_url:shop_url,customer_id:customer_id,firstname:firstname,lastname:lastname,country:country,address:address,address_2:address_2,company:company,city:city,postal_code:postal_code},
            success: function (res) {
               debugger;
                   if(res == 1){
                  	window.location.reload();
                  }    

            },
            error: function () {
                alert("Something went wrong");
            }
      });	
    
  })
  
  $(document).on('click', '.Page_change', function () {
        debugger;
        var page = $(this).text();
        if (page == "")
        {
            var current_page = $(".page_item.paginate_num.active").text();
            var total_page = $(this).data('total-page');
            if (current_page == total_page)
            {
                return false;
            }
            else
            {
                page = parseInt(current_page) + 1;
            }
        }
        OrderDetails(page);
    });
  
  
  
  function OrderDetails(page){
  	debugger;
    	var page_no = 1;
    	  if (page)
            {
                page_no = page;
            }
            var take = 10;
   		  $.ajax({
                url: base_url + 'order_history',
                method: 'GET',
                dataType: 'json',
                contentType: "application/json",
                async: false,
           		data: {'shop_url':shop_url,customer_id:customer_id,page_no:page_no,take:take},
                success: function (response) {
                  debugger;
                  if(response !=1 && response != 2){
                  	
                    var OrdDetlen=response[0].length
                    var i=0;
                    var details="";
                    
                    for(i=0;i<OrdDetlen;i++){
                      var j = i+1;	
                      var y = (response[0][i].order_date).split('-'); 
                      var month_name = function(dt){
                      mlist = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
                        return mlist[dt.getMonth()];
                      };

                      var month=month_name(new Date(response[0][i].order_date));
                      var year = y[0];
                      var date =y[2];
                      var orderdate= date+" "+month+" "+ year;
                
                      details +="<tr><td><a href='javascript:void(0)'>"+response[0][i].order_number+"</a></td><td>$"+response[0][i].total_price+"</td><td>"+orderdate+"</td></tr>"
				      
                    }
                    
                    var Totalpages=response[1];
                    var PaginationHtml="";
                    
                    if(Totalpages > 1){
                    
                      for (var i = 1; i <= Totalpages; i++)
                        {
                            var active_cls = page_no == i ? 'active' : '';
                            PaginationHtml += "<li class='page_item paginate_num "+active_cls+"'><a href='javascript:void(0);' class='Page_change' data-total-page=" + Totalpages + ">"+i +"</a></li>";
                            if (i == Totalpages)
                            {
                                PaginationHtml += "<li class='page_item paginate_num arrow'><a href='javascript:void(0);' class='Page_change' data-total-page=" + Totalpages + "><img src=//cdn.shopify.com/s/files/1/0252/3974/8694/t/2/assets/pagi_right_arrow_small.png?3089></a></li>";
                            }
                        }
                      
                    }
                    
                    var display="<p>Displaying "+response[3]+" - "+response[4]+" of "+response[2]+" records</p>";
                    $('#display_record').html(display);
                    
                    $('#orderDetails').html(details);
                    $('#pagination').html(PaginationHtml);
                    
                  }else{
                  
                    $('.manage_subscription').html("You are not Subscribe User");
                    
                  
                  }
                  
                },
                error:function(){
                	alert('error');
                }	
    	 	});
	}

$('.address_details').on('click',function(){
	debugger;
   var values=$(this).closest('.address').find('h6').text();
  if(values == "Shipping Information"){
    $('#shipping_details').show();
  	$(this).closest('.address').find('.info').hide();
    $(this).closest('.address').find('a').hide();
  }else{
    $('#billing_details').show()
  	$(this).closest('.address').find('.info').hide();
    $(this).closest('.address').find('a').hide();
  }
	
});

$('#subscribtion_status').on('click',function(){
	debugger;
  
       		$.ajax({
                  url: base_url + 'subscription_status',
                  method: 'GET',
                  dataType: 'json',
                  contentType: "application/json",
                  async: false,
                  data: {'shop_url':shop_url,customer_id:customer_id},
                  success: function (response) {
                      debugger;
                    if(response== 1){
                    	window.location.reload();
                    }
                  },
                 error:function(){
                      alert('error');	
                 }
      		 });
  
});

function SubscribtionProduct(){
  debugger;
  
 		 $.ajax({
                  url: base_url + 'productsubscription',
                  method: 'GET',
                  dataType: 'json',
                  contentType: "application/json",
                  async: false,
                  data: {'shop_url':shop_url,customer_id:customer_id},
                  success: function (response) {
                      debugger;
                    if(response !=1 && response !=2){
                    	
                      var Allproducts="";
                      var i=0;
                      var length_pro=response[1].length;
                      for(i;i<length_pro;i++){
                      	
                        Allproducts +="<option value="+response[1][i].productid_shopify+">"+response[1][i].product_name+"</option>";
                      
                      }
                      
                      var Subprodname="";
                      var ProImg="";
                      var j =0;
                      var len_sub=response[0].length;
                      
                      for(j;j<len_sub;j++){
                      	var res=response[0][j].split(',');
                        
                      	if(res[1] == "default.png"){
                          
                        	Subprodname += "<div class='product_sub_contain'><div class='product_sub_img'><img src='//cdn.shopify.com/s/files/1/0252/3974/8694/t/2/assets/upload_img_small.png?3746'></div>";
                        }else{
                        	Subprodname += "<div class='product_sub_contain'><div class='product_sub_img'><img src="+res[1]+"></div>";
                        }
                        Subprodname +="<div class='product_sub_text'><div class='product_sub_width'><p>"+res[0]+"</p><a href='javascript:void(0)' data-id="+res[2]+" class='swap product_swap'>Swap Product</a></div>"+
                          '<div class="product_sub_width text_center swap_products" style="display:none">'+
                          '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="29" viewBox="0 0 24 29"><g><g><path fill="#36b" d="M8.553 12.433a1.5 1.5 0 0 1-2.122 2.122L.429 8.553a1.497 1.497 0 0 1-.1-.11c-.014-.017-.026-.036-.04-.054l-.047-.064-.04-.065-.035-.06-.033-.069-.03-.065c-.01-.022-.017-.045-.025-.067l-.025-.071-.017-.069C.03 7.835.024 7.81.019 7.785c-.005-.026-.009-.053-.012-.08a1.52 1.52 0 0 1-.01-.362C0 7.323.004 7.3.007 7.279l.012-.08.018-.073c.006-.023.01-.046.017-.069l.025-.071.025-.067.03-.065c.01-.023.02-.046.033-.068.011-.021.024-.04.036-.061.013-.022.025-.044.04-.065.014-.023.03-.043.047-.065.013-.018.025-.036.04-.053.031-.038.064-.075.1-.11l6-6.002A1.5 1.5 0 0 1 8.554 2.55l-3.44 3.44h17.383a1.5 1.5 0 0 1 0 3.001H5.112zm15.009 10.122l-.002.001-6.001 6.003a1.5 1.5 0 1 1-2.122-2.123l3.44-3.44H1.494a1.5 1.5 0 1 1 0-3.001h17.383l-3.44-3.44a1.5 1.5 0 0 1 2.122-2.123l6.001 6.002.002.002c.034.034.067.07.098.108l.04.054.047.064c.015.022.027.044.04.066l.036.06c.012.022.022.045.033.068l.03.065c.009.022.016.045.024.067.009.024.018.047.025.072.007.022.012.045.018.068.006.025.013.049.018.074.005.026.008.053.012.08l.01.065c.01.099.01.198 0 .296l-.01.066-.012.08c-.005.025-.012.049-.018.074l-.018.068c-.007.024-.016.047-.025.071-.008.023-.015.045-.024.067l-.03.065c-.011.023-.021.046-.033.068-.011.021-.024.04-.036.06-.013.023-.025.045-.04.066l-.047.065-.04.053a1.59 1.59 0 0 1-.098.109z"/></g></g></svg>'+
                          '<p>Swapping product with</p>'+
                          '</div>'+
                          '<div class="product_sub_width swap_products" style="display:none">'+
                          '<p>Rum Agricole</p>'+
                          '<select name="all_product" id="all_product">'+Allproducts+
                          '</select>'+
                          '<a href="javascript:void(0)" class="swap select_swap select_swap_product">Select</a>'+
                          '<a href="javascript:void(0)" class="swap cancel_swap hide_swap_product">Cancel swap</a>'+
                          '</div>'+
                          "</div></div>";
                      	
                      }
                      
                      
//                       $('#all_product').html(Allproducts);
                   	  $('#productdetails').html(Subprodname);
                    }else if(response == 2){
                    	$('.manage_subscription').html("You Plan is Deactivated");
                    }else{
                    	$('#productdetails').html("you are not selected subscription product");
                    }
                    
                  },
                 error:function(){
                      alert('error');	
                 }
      		 });
  
}
function ManageUpcomingOrder(){
	debugger;
  
  		$.ajax({
                  url: base_url + 'manageupcomingorder',
                  method: 'GET',
                  dataType: 'json',
                  contentType: "application/json",
                  async: false,
                  data: {'shop_url':shop_url,customer_id:customer_id},
                  success: function (response) {
                      debugger;
                    if(response !=1 && response !=2){
                     var len_manageOrd=response[0].length;
                     var ManageOrd='';
                      var Manage="";
                      var pro='';
                     var k=0;
                      var img="";
                      for(k;k<len_manageOrd;k++){
                        
                        var Product= response[0][k].split(',');
                       
                        pro +='<p>'+Product[0]+' x '+Product[1]+'</p>';  
                        
                      }
                       if(response[2] == "default.png"){
                        	img='//cdn.shopify.com/s/files/1/0252/3974/8694/t/2/assets/upload_img_small.png?3746';
                        }else{
                        	img ="https://winebottles.aliansoftware.net/public/images/PlanImages/"+response[2]+"";
                        }
                      
                      ManageOrd ='<div class="manage_section"><div class="manage_img"><img src="'+img+'"></div><div class="manage_description"><div class="col_6"><h6>Order date</h6><p>'+response[1]+'</p><h6 class="m-t">Products</h6><p>'+pro+'</p></div><div class="col_6"><div class="change_date Upcoming_Ord" style="display:none"><p>Next Order Date</p><input type="text" id="datepicker1"  class="datepicker"><p><span>This will also change the order date for all future orders according to the frequency of your subscription. Please note this change will also revert any choices made for upcoming orders back to their original selections. Your next order will process on the date selected.</span></p><a href="javascript:void(0)" class="swap cancel_swap">Cancel</a><a href="javascript:void(0)" id="datepicker1_btn" class="swap select_swap update_order_date">Save Changes</a></div><a href="javascript:void(0)" class="blue_link show_ord_date">Change Date</a></div></div></div>';
                      	
                      $('#manageorder').html(ManageOrd);
                      
                      var mainPlanImg="<img src='"+img+"'>";
                      
                      var planbottal=""+response[3]+" Wine Bottles Plan Subscription";
                      
                      var orderdate="Next Order Date : "+response[1]+" <a href='javascript:void(0)' class='blue_link main_show_ord_date'>Change Date</a>";
                      var date = myDateFormatter(response[1]);
                      
                      $('#datepicker2').val(date);
                      $('#datepicker1').val(date);
                      $('#plan_img').html(mainPlanImg);
                      $('#numberofbottal').html(planbottal);
                      $('#header_ord_date').html(orderdate);
                    }else if(response == 2){
                    	$('.manage_subscription').html("You Plan is DeActivated");
                    }else{
                    
                      $('#manageorder').html("your are not subscriber");
                    
                    }
                    
                  },
                 error:function(){
                      alert('error');	
                 }
      		 });

}
    
function myDateFormatter (date) {
        var d = new Date(date);
        var day = d.getDate();
        var month = d.getMonth() + 1;
        var year = d.getFullYear();
        if (day < 10) {
            day = "0" + day;
        }
        if (month < 10) {
            month = "0" + month;
        }
        var date = month + "/" + day + "/" + year;

        return date;
    };     

$(document).on('click','.show_ord_date',function(){
	debugger;
  $('.Upcoming_Ord').show();
  $('.show_ord_date').hide();
});

$('.main_show_ord_date').on('click',function(){
	debugger;
  $('.Upcoming_Ord_main').show();
  
});

$(document).on('click','.cancel_swap',function(){
	debugger;
  	$('.Upcoming_Ord').hide();
  $('.show_ord_date').show();
  $('.Upcoming_Ord_main').hide();
});

$('#datepicker1_btn').on('click',function(){
	debugger;
  var order_date=$('#datepicker1').val();
  			$.ajax({
                  url: base_url + 'updateupcomingorddate',
                  method: 'GET',
                  dataType: 'json',
                  contentType: "application/json",
                  async: false,
                  data: {'shop_url':shop_url,customer_id:customer_id,order_date:order_date},
                  success: function (response) {
                      debugger;
                    if(response ==1){
                    	window.location.reload();
                    }
                  
                  },
                 error:function(){
                      alert('error');	
                 }
      		});
});

$('#datepicker2_btn').on('click',function(){
	debugger;
  var order_date=$('#datepicker2').val();
  			$.ajax({
                  url: base_url + 'updateupcomingorddate',
                  method: 'GET',
                  dataType: 'json',
                  contentType: "application/json",
                  async: false,
                  data: {'shop_url':shop_url,customer_id:customer_id,order_date:order_date},
                  success: function (response) {
                      debugger;
                    if(response ==1){
                    	window.location.reload();
                    }
                  
                  },
                 error:function(){
                      alert('error');	
                 }
      		});
});    
    
    
$('.product_swap').on('click',function(){
	debugger;
  var product_id=$(this).attr('data-id');
  var hid_pro="<input type='hidden' name='productId' value='"+product_id+"'  id='productId'/>";
  $(this).closest('.product_sub_width').next('.swap_products').next('.swap_products').append(hid_pro);
  $(this).closest('.product_sub_width').next('.swap_products').show();
  $(this).closest('.product_sub_width').next('.swap_products').next('.swap_products').show();
  
});

$('.hide_swap_product').on('click',function(){
	debugger;
  $(this).closest('.swap_products').hide();
  $(this).closest('.swap_products').prev('.swap_products').hide();
});

$('.select_swap_product').on('click',function(){
	debugger;
   var productId=$(this).closest('.swap_products').find('#all_product').val();
   var old_proId=$('#productId').val();
 		 $.ajax({
                  url: base_url + 'swapproduct',
                  method: 'GET',
                  dataType: 'json',
                  contentType: "application/json",
                  async: false,
          		  data: {'shop_url':shop_url,customer_id:customer_id,old_proId:old_proId,productId:productId},
                  success: function (response) {
                      debugger;
                    if(response ==1){
                    	window.location.reload();
                    }
                  
                  },
                 error:function(){
                      alert('error');	
                 }
      		});
});
  
  }
  
	
}

// $(document).on('change','.quantity',function(e){
//          debugger;
//         $('.error').remove();
       

//         e.preventDefault();
//         var id = $(this).attr('id');
//        	var id1 = id.replace('updates_','');
       
// 		var ids = localStorage.getItem('plan_ids');
//        var qty = $(this).val();
// //         var id2 = parseInt(id1);
//         var ids1=ids.split(','); 
//        if(jQuery.inArray(id1, ids1) !== -1){
       	
         
//          	 if(qty>1){

//           $(this).closest('.product-quantity-box').after('<span class="error">You can not add more or less than 1 quantity</span>');

//           $(this).val(1);
//           setTimeout(function(){
//             $('.error').remove();
//           }, 2000);  

//           return false;
//         }
       
//        }else{
       
       		
       
       
//        }
       
        


//       })

  